webpackJsonp([1],{

/***/ 17:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "App"
});

/***/ }),

/***/ 18:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Dice__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(33);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Roll",
  data: function data() {
    return {
      formDices: "",
      sides: 6,
      rolls: []
    };
  },

  components: {
    dice: __WEBPACK_IMPORTED_MODULE_1__components_Dice__["a" /* default */]
  },
  computed: {
    canRoll: function canRoll() {
      return this.dices > 0 && this.dices <= 200;
    },
    hasRolls: function hasRolls() {
      return this.rolls.length > 0;
    },
    dices: function dices() {
      return this.parseFormDataNumber(this.formDices);
    },
    hits: function hits() {
      return this.rolls.filter(function (r) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* isHit */])(r);
      }).length;
    },
    glitches: function glitches() {
      return this.rolls.filter(function (r) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* isGlitch */])(r);
      }).length;
    },
    isPassed: function isPassed() {
      return this.hits > 0;
    },
    isGlitch: function isGlitch() {
      var rollsLength = this.rolls.length;
      return rollsLength > 0 && this.glitches >= rollsLength / 2;
    },
    isCriticalGlitch: function isCriticalGlitch() {
      console.log("Is critical glitch?", !this.isPassed && this.isGlitch);
      return !this.isPassed && this.isGlitch;
    }
  },
  methods: {
    parseFormDataNumber: function parseFormDataNumber(data) {
      return parseInt(data || "0", 10);
    },
    throwDices: function throwDices() {
      var _this = this;

      return this.rolls = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(Array(this.dices).keys())).map(function () {
        return {
          sides: _this.sides,
          result: Math.ceil(Math.random() * _this.sides),
          hash: _this.makeRandomHash()
        };
      });
    },
    makeRandomHash: function makeRandomHash() {
      var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

      return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(Array(this.sides + 1).keys())).reduce(function (text) {
        return text += possible.charAt(Math.floor(Math.random() * possible.length));
      }, "");
    }
  }
});

/***/ }),

/***/ 32:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(33);
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Dice",
  props: {
    dice: {
      result: Number,
      sides: Number
    }
  },
  computed: {
    result: function result() {
      return this.dice.result;
    },
    isHit: function isHit() {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["b" /* isHit */])(this.dice);
    },
    isGlitch: function isGlitch() {
      return Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* isGlitch */])(this.dice);
    }
  }
});

/***/ }),

/***/ 33:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isHit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isGlitch; });
var isHit = function isHit(_ref) {
  var result = _ref.result,
      sides = _ref.sides;
  return result >= sides - 1;
};
var isGlitch = function isGlitch(_ref2) {
  var result = _ref2.result;
  return result === 1;
};

/***/ }),

/***/ 34:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(43);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] },
  template: '<App/>'
});

/***/ }),

/***/ 38:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(17);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0302045f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(41);
function injectStyle (ssrContext) {
  __webpack_require__(39)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0302045f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 39:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 41:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('img',{attrs:{"src":__webpack_require__(42)}}),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.a266b53.png";

/***/ }),

/***/ 43:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Roll__ = __webpack_require__(45);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Roll',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Roll__["a" /* default */]
  }]
}));

/***/ }),

/***/ 45:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Roll_vue__ = __webpack_require__(18);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4113e113_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Roll_vue__ = __webpack_require__(77);
function injectStyle (ssrContext) {
  __webpack_require__(46)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4113e113"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Roll_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4113e113_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Roll_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 46:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 74:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dice_vue__ = __webpack_require__(32);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_879ebcf2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dice_vue__ = __webpack_require__(76);
function injectStyle (ssrContext) {
  __webpack_require__(75)
}
var normalizeComponent = __webpack_require__(9)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_879ebcf2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 75:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 76:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dice",class:{hit: _vm.isHit, glitch: _vm.isGlitch}},[_vm._v(_vm._s(_vm.result))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 77:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"roll"},[_c('h1',[_vm._v("SR5 Roll")]),_vm._v(" "),_c('div',{staticClass:"form"},[_c('div',{staticClass:"form-control"},[_c('label',[_vm._v("\n        Dices:\n        "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formDices),expression:"formDices"}],attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.formDices)},on:{"input":function($event){if($event.target.composing){ return; }_vm.formDices=$event.target.value}}})])])]),_vm._v(" "),(_vm.canRoll)?_c('h2',{staticClass:"roll-preview"},[_c('span',[_vm._v(_vm._s(_vm.dices))]),_vm._v(" "),_c('span',[_vm._v("D")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.sides))])]):_vm._e(),_vm._v(" "),(_vm.hasRolls)?_c('div',{staticClass:"results",class:{glitched:_vm.isCriticalGlitch}},[_c('div',{staticClass:"summary"},[_c('span',{staticClass:"summary-hits",class:{passed:_vm.isPassed}},[_c('div',[_vm._v("Hits:")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.hits))])]),_vm._v(" "),_c('span',{staticClass:"summary-glitches",class:{glitched:_vm.glitches}},[_c('div',[_vm._v("Glitches:")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.glitches))])])]),_vm._v(" "),_c('div',{staticClass:"list",class:{glitched:_vm.isGlitch}},_vm._l((_vm.rolls),function(dice){return _c('dice',{key:dice.hash,attrs:{"dice":dice}})}))]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"roll-button",class:{disabled:!_vm.canRoll},attrs:{"disabled":!_vm.canRoll},on:{"click":function($event){_vm.throwDices()}}},[_vm._v("PRESS TO ROLL")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},[34]);


// WEBPACK FOOTER //
// static/js/app.53a16b75c1d0c761eb14.js